<ng-container *ngIf="reportLoaded">
    <section class="section-buttons">
      <button (click)="closeSettings()" [matTooltip]="'Close'" matTooltipClass="tooltip-font-14">
        <i class="fal fa-times-circle"></i>
      </button>
      <button (click)="expandSettings()" [matTooltip]="page.reportExpanded?'Minimise':'Maximise'" matTooltipClass="tooltip-font-14">
        <i class="fal" [class]="page.reportExpanded?'fa-compress':'fa-expand'"></i>
      </button>
    </section>

    <app-reports-basic-info [report]="report" [infoAllColumns]="page.infoAllColumns" [gridItem]="gridItem">
    </app-reports-basic-info>

    <app-web-engage-reports-settings [report]="report" [gridItem]="gridItem" [columns]="columns" [(rdp_data)]="rdp_data" [showColumnButton]="showColumnButton" [isFromDashboard]="isFromDashboard"
                                     (completedNotifier)="viewReport()" (gridItemSetupChangedNotifier)="notifyReportModified()" (columnOrderChangedNotifier)="columnOrderEvent($event)">
    </app-web-engage-reports-settings>

    <app-web-engage-reports-viualization [report]="report" [gridItem]="gridItem" [(rdp_data)]="rdp_data" [canExport]="canExport" (reportFullscreenNotifier)="reportFullscreen()"
                    [viewReportObservable$]="viewReportSubject$.asObservable()" [orderColumnsNotifier$]="orderColumnsNotifier$" (exportReportNotifier)="exportReport()"
                    (showColumnButtonNotifier)="showColumnButton = $event">
    </app-web-engage-reports-viualization>

    <app-reports-save-buttons [report]="report" [gridItem]="gridItem" (cancelButtonNotifier)="closeSettings()" (reportSavedNotifier)="reportSavedHandler()"
                              (saveAsDilogClosedNotifier)="saveAsDilogClosedHandler($event)">
    </app-reports-save-buttons>

    <div *ngIf="showColumnOrder" class="backdrop" (click)="showColumnOrder=false"></div>
</ng-container>

<app-data-loading *ngIf="!dataLoaded"></app-data-loading>
